import { styled } from '@mui/material/styles';
const BarDeliver = styled('div')(({ theme }) => ({
  backgroundColor: '#e8e8e8',
  width: '45%',
  display: 'inline-block',
  [theme.breakpoints.up('sm')]: {
    width: 150,
    display: 'inherit'
  },
  height: 24,
  borderRadius: '5px',
  position: 'relative',
  overflow: 'inherit'
}));

export default BarDeliver;
